// src/pages/LoginPage.jsx
import { useState } from "react";
import {
  AUTH_API_BASE_URL,
  AUTH_TOKEN_PATH,
  STORAGE_PREFIX,
} from "@config";
import { useNavigate } from "react-router-dom";
import { invalidateMeCache } from "../../../shared/common/useMe";

function LoginPage({ setIsAuthenticated, setToken, setClubId }) {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const k = (name) => `${STORAGE_PREFIX}${name}`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const response = await fetch(`${AUTH_API_BASE_URL}${AUTH_TOKEN_PATH}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          login,
          password,
          application: "monitoring",
        }),
      });

      const data = await response.json();

      if (response.ok && data.access_token) {
        localStorage.setItem(k("token"), data.access_token);
        localStorage.setItem(k("refresh_token"), data.refresh_token);
        localStorage.setItem(k("user_id"), data.user_id);
        localStorage.setItem(k("club_id"), data.club_id);
        if (data.app) localStorage.setItem(k("app"), data.app);

        invalidateMeCache();

        // 🔹 Mise à jour de l'état global (App)
        setToken(data.access_token);
        setClubId(data.club_id);
        setIsAuthenticated(true);

        navigate("/overview");} else if (response.status === 429) {
        setError(data.reason || "Too many login attempts. Please try again later.");      } else {
        const errorMessage =
          typeof data.error === "string"
            ? data.error
            : data.error?.message || "Invalid credentials.";
        setError(errorMessage);
      }
    } catch (error) {
     
      setError("An error occurred while trying to log in.");
    }
  };

  return (
    <div className="flex justify-center items-center h-screen w-screen bg-gray-800 z-10">
      <div className="bg-white p-8 rounded-lg shadow-lg w-96">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img src="/logo-light.png" alt="Logo" className="h-50 w-50" />
        </div>

        <h2 className="text-2xl text-black font-bold mb-6 text-center"></h2>
        {error && <p className="text-red-500 mb-4">{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Login</label>
            <input
              type="text"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              className="w-full p-2 border text-gray-700 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-2 border text-gray-700 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;
